<template>
  <div class="right">
    <div class="top">
      <div class="login" to="/escolher-conta" @click="handleModal">
        <img
          src="../assets/images/icon-login-green.svg"
          alt="icone login"/>
          Criar nova conta
      </div>
      <h1>Acesse sua conta</h1>
    </div>
    <!-- <div class="social">
      <a @click.prevent="handleLoginWithFacebook" class="fb bt-social">
        <img src="../assets/images/facebook.svg" alt="facebook" />
        <span>Facebook</span>
      </a>
      <a @click.prevent="handleLoginWithGmail" id="gg-signin-button" class="google bt-social"
        ><img src="../assets/images/google.svg" alt="google" />
        <span>Google</span>
      </a> -->
      <!-- <a href="#" class="twitter bt-social">
        <img src="../assets/images/linkedin.svg" alt="facebook" />
        <span>Linkedin</span>
      </a> -->
    <!-- </div> -->

    <form v-on:submit="handleSubmit" id="form-contato" class="form">
      <div class="form-group">
        <label for="login">Login</label>
        <input
          v-model="user.email"
          type="text"
          name="login"
          class="js-input"
          id="login"
        />
      </div>
      <div class="form-group">
        <label for="senha">Senha</label>
        <input
          v-model="user.password"
          type="password"
          name="senha"
          class="js-input password"
          id="senha"
          onmouseover="this.type='text'"
          onmouseout="this.type='password'"
        />
        <div class="icon">
          <img src="../assets/images/olho-green.svg" alt="icone senha" />
        </div>
      </div>
      <div class="form-group">
        <a href="https://dashboard-app.iouu.com.br/#/recuperar-senha"
          ><img
            src="../assets/images/icon-cadeado-aberto.svg"
            alt="icone cadeado"
          />
          Esqueci minha senha</a
        >
      </div>
      <div class="form-group">
        <button class="btn" type="submit">
          Acessar minha conta
          <img src="../assets/images/icon-arrow-right.svg" alt="icone seta" />
        </button>
      </div>
    </form>
  </div>
</template>

<script>
// import * as mutationTypes from '@/store/mutation-types.js'
// import SessionManager from '@/utils/session-manager'

export default {
  data() {
    return {
      user: {
        email: "",
        password: "",
      },
    };
  },
  methods: {
    handleSubmit(event) {
      event.preventDefault();
      this.$emit("userData", this.user);
    },
    async handleLoginWithFacebook() {
      this.$emit('facebook')
    },
    async handleLoginWithGmail() {
      this.$emit('gmail')
    },
    handleModal() {
      this.$emit("setOpenModal")
    }
  },
};
</script>

<style lang="scss" scoped>
$verde: #41d3bd;
$azul: #21247f;
$azul-sec: #3b46c4;
$branco: #ffffff;
$cinza-claro: #e9eafa;
$cinza-medio: #818495;
$cinza-escuro: #2c3236;
.right {
  width: 488px;

  .top {
    margin-bottom: 36px;
    .login {
      display: flex;
      color: $azul;
      margin-bottom: 92px;
      transition: all 0.3s;
      img {
        margin-right: 16px;
      }
      &:hover {
        transition: all 0.3s;
        color: $verde;
      }
    }
    h1 {
      margin-bottom: 24px;
      color: $cinza-escuro;
    }
  }

  .social {
    margin-bottom: 51px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    a {
      width: 49%;
      height: 52px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: $cinza-claro;
      border: 1px solid $cinza-claro;
      border-radius: 4px;
      transition: all 0.3s;

      span {
        font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
        font-weight: 500;
        font-size: 0.875rem;
        line-height: 130%;
        letter-spacing: 0.01em;
        color: $azul;
      }
      img {
        margin-right: 10px;
      }
      &:hover {
        transition: all 0.3s;
        border: 1px solid $azul;
      }
    }
  }

  .form {
    display: flex;
    flex-direction: column;

    .form-group {
      .btn {
        width: 386px;
        height: 59px;
        color: $branco;
      }
      &:nth-child(5) {
        margin-bottom: 47px;
        flex-direction: row;
        justify-content: flex-start;

        label {
          max-width: 378px;
          position: relative;
          font-size: 14px;
          line-height: 150%;
          letter-spacing: 0.01em;
          color: $cinza-medio;
        }

        input[type="checkbox"] {
          border: 1px solid #818495;
          width: 20px;
          height: 20px;
          cursor: pointer;
          position: relative;
        }
      }
      .icon {
        height: 100%;
        width: 64px;
        z-index: 3;
        position: absolute;
        top: 0;
        right: 0;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}
.form {
  display: flex;
  flex-direction: column;

  .form-group {
    position: relative;
    margin-bottom: 26px;
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border-radius: 4px;
    a {
      display: flex;
      color: $cinza-medio;
      align-items: center;
      img {
        margin-right: 18px;
      }
    }
    &:last-child {
      margin-bottom: 0;
    }
    &.focus {
      label {
        font-size: 12px;
        top: 12px;
        transition: all 0.3s;
      }
    }
    label {
      font-size: 0.875rem;
      line-height: 150%;
      letter-spacing: 0.01em;
      color: #616e8e;
      position: absolute;
      top: -11px;
      left: 18px;
      pointer-events: none;
      transition: all 0.3s;
      background-color: $branco;
      padding: 0 6px;
      font-weight: normal;
      &.error {
        position: relative;
        top: 0;
        left: 0;
        font-size: 13px;
        margin-top: 10px;
        margin-left: 5px;
        color: $cinza-escuro;
      }
    }

    input[type="text"],
    input[type="email"],
    input[type="password"] {
      width: 100%;
      border: 1px solid rgba(97, 110, 142, 0.2);
      height: 52px;
      border-radius: 4px;
      background: transparent;
      font-size: 0.875rem;
      line-height: 150%;
      letter-spacing: 0.01em;
      color: #616e8e;
      padding: 0px 18px;
      &.error {
        border: 1px solid red;
      }
    }

    .btn {
      span {
        font-size: 0.9375rem;
        line-height: 150%;
        letter-spacing: 0.02em;
      }
      img {
        margin-left: 22px;
      }
    }
  }
}
.btn {
  width: 238px;
  height: 64px;
  background-color: $verde;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s;
  span {
    font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
    font-weight: bold;
    font-size: 1.125rem;
    line-height: 135%;
    letter-spacing: 0.005em;
    color: $branco;
  }

  &:hover {
    transition: all 0.3s;
    background-color: $azul;
  }
}
@media (max-width: 1050px) {
  .right {
    width: 509px;

    .top {
      display: flex;
      flex-direction: column;
      align-items: center;
      .login {
        margin-bottom: 24px !important;
      }
      h1 {
        text-align: center;
        font-size: 2rem;
      }
    }
    .form {
      .form-group {
        &:last-child {
          align-items: center;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/FormNewLogin.vue